module.exports = __webpack_public_path__ + "static/img/pc_hd_icon2.934c865.png";